<template>
  <el-table :data="tableData" style="width: 100%" size='mini' :max-height='240'>
    <el-table-column prop="bikeId" label="车辆编码"> </el-table-column>
    <el-table-column prop="miUserName" label="操作人"> </el-table-column>
    <el-table-column prop="createTime" label="入库时间"  > </el-table-column>
    <el-table-column prop="bleName" label="广播name" v-if='params.isBlue'> </el-table-column>
    <el-table-column prop="brandName" label="自动匹配" v-else> </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
    },
    params: {
      type: Object
    }
  },
};
</script>

<style>
</style>